import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Layout, Widget } from 'components';
import ContentCard from 'components/ContentCard';
import { TitleChart, TitleCalendar, Legend, Main } from './styles';
import { Chart } from "react-google-charts";
import { Col, Row } from 'components/Grid';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import Colors from 'constants/Colors';

const data = [
    {
        title: "YTD Brokerage",
        value: "539.388",
        subtitle: "% Budget",
        result: "71,9%"
    },
    {
        title: "P&L",
        value: "-269.694",
        subtitle: "% Budget",
        result: "-24,8%"
    },
    {
        title: "On-going Deals",
        value: "13",
        subtitle: "Pipeline Brokerage",
        result: "290.000"
    }
];

// 2020-11-09 - carlos.oliveira - retornando dash mockup enquanto microsoft resolve problema do licenciamento
//const isDashboardContentEmbed = Boolean(true);
const isDashboardContentEmbed = Boolean(false);

const getDashbordContentMock = function (month, selectedDays) {
    return (
        <Main>
            <Row>
                {data.map((item, index) => <Col sm={12} md={4} key={index}><Widget info={item} /></Col>)}
            </Row>
            <Row>
                <Col xs={12} md={7}>
                    <TitleChart>Total Premium</TitleChart>
                    <Chart
                        width={'100%'}
                        height={'250px'}
                        chartType="ColumnChart"
                        loader={<div>Loading Chart</div>}
                        legendToggle

                        diffdata={{
                            old: [
                                ['Name', 'Paid'],
                                ['2019', 376232],
                                ['2020', 404550],
                                ['2021', 321400],
                                ['2022', 271850],
                                ['2023', 171900],
                            ],
                            new: [
                                ['Name', 'Paid',],
                                ['2019', 376232],
                                ['2020', 320000],
                                ['2021', 0],
                                ['2022', 0],
                                ['2023', 0],
                            ],
                        }}
                        options={{
                            legend: { position: 'none' },
                            diff: {
                                oldData: {
                                    color: '#6BCABA',
                                    tooltip: {
                                        prefix: 'Projected'
                                    }
                                },
                                newData: {
                                    widthFactor: 1,
                                    tooltip: {
                                        prefix: 'Paid'
                                    }
                                }
                            },
                            colors: [Colors.PRIMARY, Colors.SECONDARY],
                            format: 'decimal',
                            enableInteractivity: true,
                            vAxis: { gridlines: { count: 1 }, textPosition: 'none' },
                            chartArea: { left: '0%', top: '0%', bottom: '10%', width: "100%", height: "100%" }
                        }}
                        rootProps={{ 'data-testid': '1' }}
                    />
                    <Legend>
                        <div className="content">
                            <p><span style={{ backgroundColor: Colors.PRIMARY }}></span>Paid</p>
                            <p><span style={{ backgroundColor: Colors.SECONDARY }}></span> Projected</p>
                        </div>
                    </Legend>
                </Col>
                <Col xs={12} md={5}>
                    <TitleChart>Margin</TitleChart>
                    <Chart
                        width={'100%'}
                        height={'250px'}
                        chartType="LineChart"
                        loader={<div>Loading Chart</div>}
                        data={[
                            [
                                { type: 'string', label: 'Month' },
                                { type: 'number', label: 'values' },
                                { id: 'i0', type: 'number', role: 'interval' },
                                { id: 'i2', type: 'number', role: 'interval' },
                                { type: 'string', role: 'annotation' }
                            ],
                            ["JAN", 68, 58, 78, "68%"],
                            ["FEV", 65, 55, 75, "65%"],
                            ["MAR", 67, 57, 77, "67%"],
                        ]}
                        options={{
                            series: [{ color: '#5d298c' }],
                            intervals: { lineWidth: 2, barWidth: 0.1, style: 'bars', 'color': 'black' },
                            legend: 'none',
                            pointSize: 10,
                            pointShape: 'circle',
                            vAxis: { gridlines: { count: 1 }, textPosition: 'none' },
                            annotations: {
                                stem: {
                                    length: 100
                                }, stemColor: 'white', textStyle: { fontSize: 12, color: "#000" }
                            },
                            chartArea: { left: '0%', top: '30%', bottom: '10%', width: "100%", height: "100%" }
                        }}
                        rootProps={{ 'data-testid': '4' }}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={5}>
                    <TitleCalendar>Expiration Calendar</TitleCalendar>
                    <DayPicker
                        initialMonth={month}
                        selectedDays={selectedDays}
                        canChangeMonth={false}
                    />
                </Col>
                <Col xs={12} md={7}>
                    <TitleChart>YTD Brokerage</TitleChart>
                    <Chart
                        width={'100%'}
                        height={'350px'}
                        chartType="ColumnChart"
                        loader={<div>Loading Chart</div>}

                        diffdata={{
                            old: [
                                ['Name', 'New Business (On-going)'],
                                ['Jan', 100000],
                                ['Feb', 200000],
                                ['Mar', 420000],
                                ['Apr', 520000],
                                ['May', 620000],
                                ['Jun', 700000],
                                ['Jul', 740000],
                                ['Aug', 750000],
                                ['Sep', 770000],
                                ['Oct', 780000],
                                ['Nov', 800000],
                                ['Dec', 820000]
                            ],
                            new: [
                                ['Name', 'Bound'],
                                ['Jan', 100000],
                                ['Feb', 200000],
                                ['Mar', 320000],
                                ['Apr', 350000],
                                ['May', 380000],
                                ['Jun', 410000],
                                ['Jul', 440000],
                                ['Aug', 450000],
                                ['Sep', 500000],
                                ['Oct', 520000],
                                ['Nov', 530000],
                                ['Dec', 550000]
                            ],
                        }}
                        options={{
                            legend: { position: 'none' },
                            series: {
                                2: {
                                    targetAxisIndex: 1
                                },
                                3: {
                                    targetAxisIndex: 1
                                },
                                4: {
                                    targetAxisIndex: 2
                                },
                                5: {
                                    targetAxisIndex: 2
                                },
                                6: {
                                    targetAxisIndex: 3
                                },
                                7: {
                                    targetAxisIndex: 3
                                }
                            },
                            diff: {
                                oldData: {
                                    color: '#6BCABA',
                                    tooltip: {
                                        prefix: 'New Business (On-going)'
                                    }
                                },
                                newData: {
                                    widthFactor: 1,
                                    tooltip: {
                                        prefix: 'Bound'
                                    }
                                }
                            },

                            colors: ['#5d298c', '#6BCABA'],
                            format: 'decimal',
                            enableInteractivity: true,
                            vAxis: { gridlines: { count: 5 } },
                            chartArea: { left: '10%', top: '10%', bottom: '10%', width: "100%", height: "100%" }
                        }}
                        rootProps={{ 'data-testid': '1' }}
                    />
                    <Legend>
                        <div className="content">
                            <p><span style={{ backgroundColor: "#5d298c" }}></span>Bound</p>
                            <p><span style={{ backgroundColor: "#6BCABA" }}></span> New Business (On-going)</p>
                        </div>
                    </Legend>
                </Col>
            </Row>
        </Main>
    );
};

const getPersonRootName = function (authContext) {
    if (authContext.login_response &&
        authContext.login_response.ret_value &&
        authContext.login_response.ret_value.rootFirstName &&
        authContext.login_response.ret_value.rootLastName) {
        return (authContext.login_response.ret_value.rootFirstName + " " + authContext.login_response.ret_value.rootLastName);
    } else {
        return ("**PERSON NAME NOT FOUND**");
    }
};

/*
 20201025 - carlos.oliveira
 teste dashboard embeded via microsoft powerbi
 TO-DOs:
 - configurar constante / acesso perfil broker / cliente (domain + função requestAccess)
 - acionar chamada perfil / accesso para determinar perfil broker / cliente
 - ajustar exibição nome pessoa root
 - obter URL endpoint do dashboard embeded via consulta ao backend (params / perfil)
*/
const getDashbordContentEmbed = function (authContext) {
    const idPersonTexel = 101703;
    let dashContentUrl;
    if (authContext.login_response &&
        authContext.login_response.ret_value &&
        authContext.login_response.ret_value.idPersonRoot) {
        if (Number(authContext.login_response.ret_value.idPersonRoot) == Number(idPersonTexel)) {
            // BROKER DASHBOARD
            dashContentUrl = "https://app.powerbi.com/reportEmbed?reportId=650c463f-9890-46d6-9b87-4ce9e77a71e5&appId=ff6f3e3d-4771-497c-9691-6a02112060db&autoAuth=true&ctid=dd21e3be-4b6a-4d7d-905a-249d4f5974ea&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWJyYXppbC1zb3V0aC1iLXByaW1hcnktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D";
        } else {
            // CLIENT DASHBOARD
            dashContentUrl = "https://app.powerbi.com/reportEmbed?reportId=220af2e6-3895-4913-98c1-60b487fff345&appId=ff6f3e3d-4771-497c-9691-6a02112060db&autoAuth=true&ctid=dd21e3be-4b6a-4d7d-905a-249d4f5974ea&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWJyYXppbC1zb3V0aC1iLXByaW1hcnktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D";
        }
    } else {
        dashContentUrl = "about:blank";
    }

    return (
        <Main>
            <Row>
                <iframe width="1140" height="541.25" src={dashContentUrl} frameborder="0" allowFullScreen="true"></iframe>
            </Row>
        </Main>
    );
}

export default function HomePage() {
    const authContext = useContext(GlobalAuthContext);
    const loading = useContext(GlobalLoaderContext);
    const [month, setMonth] = useState(new Date(2020, 4));
    const [selectedDays, setSelectedDays] = useState([
        new Date(2020, 4, 1),
        new Date(2020, 4, 14),
        new Date(2020, 4, 21),
        new Date(2020, 4, 24)
    ]);

    const history = useHistory();
    const goToLoginPage = () => {
        history.push('login');
    };

    useEffect(() => {
        loading.start();

        /* if (authContext.status != true) {
            goToLoginPage();
        } */
        loading.stop();
    }, []);

    return (
        <>
            <Layout title={'Painel'}>
                <ContentCard title="Painel">
                    {/* <Heading>Dashboard - { getPersonRootName(authContext) }</Heading> 
            
                
                { !isDashboardContentEmbed && getDashbordContentMock(month, selectedDays) }
                { isDashboardContentEmbed && getDashbordContentEmbed(authContext) }
                
            */}
                    <h2>Em construção</h2>
                </ContentCard>
            </Layout>
        </>
    );
}